export default __webpack_public_path__ + "static/media/help-primary.1b1fd324.svg";